import DateFormat from '@/shared/utils/date-format';

export default class ErrorMonitorFilter {
  contractExternalId?: number;

  customerName?: string;

  type?: string;

  selectedDates: Array<string>;

  periodStart?: string;

  periodEnd?: string;

  constructor(obj: any) {
    this.contractExternalId = obj.contractExternalId || null;
    this.customerName = obj.customerName || null;
    this.type = obj.type || null;
    this.selectedDates = obj.selectedDates || [];
    this.periodStart = obj.periodStart || null;
    this.periodEnd = obj.periodEnd || null;
  }

  public static of(obj: any) {
    return new ErrorMonitorFilter(obj || {})
  }

  public toRequest(): any {
    return this;
  }

  prepareToSend() {
    this.setDates();
  }

  private setDates(): void {
    if (this.selectedDates.length > 1) {
      this.selectedDates = this.selectedDates.map((el: string) => DateFormat.timestampToLocal(el))
      this.periodStart = DateFormat.formatToIsoDate(this.selectedDates[0]);
      this.periodEnd = DateFormat.formatToIsoDate(this.selectedDates[1]);
      this.selectedDates = [];
    }
  }
}
